const FALLBACK_APPROVED_COUNTRIES_LIST = [
  'AD',
  'AL',
  'AS',
  'AT',
  'AU',
  'BA',
  'BE',
  'BG',
  'CA',
  'CH',
  'CR',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GB',
  'GR',
  'GU',
  'HR',
  'HU',
  'IE',
  'IS',
  'IT',
  'JP',
  'LI',
  'LT',
  'LU',
  'LV',
  'MC',
  'ME',
  'MK',
  'MP',
  'MT',
  'MX',
  'NL',
  'NO',
  'NZ',
  'PL',
  'PR',
  'PT',
  'RO',
  'RS',
  'SE',
  'SI',
  'SK',
  'SM',
  'US',
  'VA',
  'VI',
  'XK',
];

export default FALLBACK_APPROVED_COUNTRIES_LIST;
